import styled from 'styled-components';

export const Slash = styled.div`
  width: 17px;
  height: 16px;
  border-bottom: solid 2px #707070;
  transform: translateY(5px) translateX(5px) rotate(135deg);
  /* position: absolute; */
`;
